define( 'models/fileModel',[], function() {
	var model = Backbone.Model.extend( {

	} );
	
	return model;
} );
